<template>
  <div class="container-fluid">
    <div class="row flex-md-row flex-column">
      <div class="col-md-4 col-12 custom-col-md-4 d-flex align-items-center">
        <div id="myCarousel" class="carousel slide" data-ride="carousel" v-if="images.length > 1">
          <ol class="carousel-indicators">
            <li
              v-for="(image, index) in images"
              :key="index"
              :data-target="'#myCarousel'"
              :data-slide-to="index"
              :class="{ active: index === 0 }"
            ></li>
          </ol>
          <div class="carousel-inner">
            <div
              v-for="(image, index) in images"
              :key="index"
              :class="['carousel-item', { active: index === 0 }]"
            >
              <img :src="image" alt="Image" class="d-block w-100" style="object-fit: cover;" />
            </div>
          </div>
          <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
        <div v-else>
          <img :src="images[0]" alt="Image" class="d-block w-100" style="object-fit: cover;" />
        </div>
      </div>
      <div class="col-md-6 col-12 custom-col-md-6">
        <h4>{{ title }}</h4><br />
        <p class="text-dark-gray" v-html="description"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        require('@/assets/images/news/11/news_02.jpg'),
        //可輪播圖片
        //EX:require('@/assets/images/news/01/news_3.png'),
      ],
      //標題
      title: '【 TSK | 臺灣整形外科醫學會年會 】',
      //內文
      description:
        '<b>TSK 邀您共赴2024臺灣整形外科醫學會年會！</b><br><br>針對精準醫療的每一刻，TSK始終以尖端工藝和高品質標準，為醫療專業人士提供安全、優質且令人安心的產品。<br><br><b>🌟 展會亮點搶先看 🌟<br> • 全系列尖針、鈍針型號現場展示<br> • 日本匠心製造，親臨攤位體驗TSK針頭的卓越手感<br> • 現場專屬優惠活動與驚喜好禮等您來參加</b><br><br><b>現場更多優惠與驚喜等您來發現，不要錯過⮕</b><br>展會時間：2024/12/7(六)-8(日)<br> 展會地點：南港展覽館2館7樓<br> 攤位編號：44',
    };
  },
};
</script>

<style scoped>
.custom-col-md-4 {
  flex: 0 0 auto;
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-col-md-6 {
  flex: 0 0 auto;
  width: 60%;
}
@media (max-width: 767.98px) {
  .custom-col-md-4,
  .custom-col-md-6 {
    flex: 0 0 auto;
    width: 100%;
  }
}
</style>
